import { ReactElement } from 'react';
import { Typography } from '@mui/material';

import { translation } from 'modules/deprecatedLiquidStaking/components/Guide/translation';
import { useTranslation } from 'modules/i18n';
import { useStakeToken } from 'modules/liquidStaking/hooks/useStakeToken';

import { useStyles } from './useStyles';

interface IGuideProps {
  className?: string;
}

export function Guide({ className }: IGuideProps): ReactElement {
  const { classes, cx } = useStyles();
  const { t, keys } = useTranslation(translation);

  const { name: token } = useStakeToken();

  return (
    <Typography className={cx(classes.root, className)} component="ol">
      <li>{t(keys.firstStep, { token })}</li>

      <li>{t(keys.secondStep, { token }, true)}</li>
    </Typography>
  );
}
